var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2639 7.95584L10.3195 11.3663L7.11436 10.6842L9.20838 16.377L17.9336 14.7633L17.9477 8.53299L15.0844 10.3956L12.2639 7.95584ZM12.2639 7.95584L12.3184 8.003M2.03992 4.37658V12.8052C2.03992 18.4831 6.3766 22.4653 12.8732 24.375C19.3699 22.4653 23.7066 18.4831 23.7066 12.8052V4.37658C16.3754 0.707866 9.37106 0.707867 2.03992 4.37658Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.fcdc1cbe936e2c25bdfe191d2217544b.svg";
export { ForwardRef as ReactComponent };